import { render, staticRenderFns } from "./SbLavadorPrincipal.vue?vue&type=template&id=415daa71&"
import script from "./SbLavadorPrincipal.vue?vue&type=script&lang=js&"
export * from "./SbLavadorPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports